import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const DELETE_SCOPE_ITEM = createAppSessionEventDefinition({
  type: "DELETE_SCOPE_ITEM",
  logSafe: {
    name: false,
  },
  create: (payload: { name: string }) => payload,
  apply: ({ payload, state }) => {
    const warnings: string[] = [];

    const previousScopeItem = state.scopeItems[payload.name];

    if (previousScopeItem != null) {
      delete state.scopeItems[payload.name];
    } else {
      // scope item name is not safe to log
      warnings.push("Scope item not found");
    }

    return { warnings };
  },
});
